export default "__VITE_ASSET__DCwn0iZl__"